import React, { ReactNode } from 'react';

export interface PriceProps {
  cond?: ReactNode,
  sum: string,
  suffix: string,
  condAfter?: ReactNode,
  noCurrency?: boolean,
}
const style = `
    .cond  p, .condAfter p {
    font-size: 12px !important;
    line-height: 19px !important;
    white-space: nowrap;
    }
    
    .condAfter {
    display: block !important;
    }
    `;

export const Price: React.FC<PriceProps> = ({
  cond,
  sum,
  suffix,
  condAfter,
  noCurrency,
}) => (
    <>
        <style>{style}</style>
        {
            <div className={`price price-left ${noCurrency ? 'price-no-currency' : ''}`}>
                {cond && <span className="cond">{cond}</span>}
                <span className="sum">{sum}</span>
                <span className="suffix">{suffix}</span>
                <span className="currency">€</span>
                {condAfter && <span className="condAfter">{condAfter}</span>}
            </div>
        }
    </>

);

export default Price;
